import { z } from 'zod'
import { json } from './http'
import type { Bindings } from '../bindings'
import { workTags, workTagsSchema } from '@/lib/work-tags'

/** The permalink exposes only public research briefs, never viewer-specific task data. */
export const PUBLIC_WORK_WHERE_SQL =
  "w.slug='research' AND w.visibility='public' AND i.status IN ('open','closed')"
export const PUBLIC_WORK_SQL = `SELECT i.id,i.kind,i.title,i.brief,i.status,i.created_at AS createdAt,
  i.base_ref AS baseRef,i.acceptance,i.tags FROM work_items i JOIN agent_workspaces w ON w.id=i.workspace_id
  WHERE ${PUBLIC_WORK_WHERE_SQL} AND i.id=`
export const publicWorkSchema = z.object({
  id: z.string().uuid(),
  kind: z.string(),
  title: z.string(),
  brief: z.string(),
  tags: workTagsSchema.default([]),
  status: z.enum(['open', 'closed']),
  createdAt: z.string(),
  baseRef: z
    .object({
      repo: z
        .string()
        .url()
        .refine((url) => url.startsWith('https://')),
      revision: z.string(),
    })
    .nullable(),
  acceptance: z.object({
    description: z.string().optional(),
    command: z.string().optional(),
  }),
})
export type PublicWork = z.infer<typeof publicWorkSchema>
export type PublicWorkRow = Omit<PublicWork, 'baseRef' | 'acceptance' | 'tags'> & {
  baseRef: string | null
  acceptance: string
  tags?: string
}
export function publicWorkView(row: PublicWorkRow): PublicWork {
  return publicWorkSchema.parse({
    ...row,
    tags: workTags(row.tags),
    baseRef: row.baseRef ? JSON.parse(row.baseRef) : null,
    acceptance: JSON.parse(row.acceptance),
  })
}
export async function readPublicWork(env: Bindings, id: string) {
  if (!z.string().uuid().safeParse(id).success)
    return json({ error: 'Work item not found' }, 404)
  const row = await env.DB.prepare(PUBLIC_WORK_SQL + '?')
    .bind(id)
    .first<PublicWorkRow>()
  return row
    ? json(publicWorkView(row))
    : json({ error: 'Work item not found' }, 404)
}
